import { render, staticRenderFns } from "./SendSMS.vue?vue&type=template&id=aa4a8312"
import script from "./SendSMS.vue?vue&type=script&lang=js"
export * from "./SendSMS.vue?vue&type=script&lang=js"
import style0 from "./SendSMS.vue?vue&type=style&index=0&id=aa4a8312&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports